import { render } from "./ManualPointsView.vue?vue&type=template&id=cdd62fc0&scoped=true"
import script from "./ManualPointsView.vue?vue&type=script&lang=js"
export * from "./ManualPointsView.vue?vue&type=script&lang=js"

import "./ManualPointsView.vue?vue&type=style&index=0&id=cdd62fc0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdd62fc0"],['__file',"ManualPointsView.vue"]])

export default __exports__